import Component from '../../../shared/component';

export default class AssetDropzone extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);

    this.photoFormSelector = '.assetDropzone-photoForm';

    this.$photoForm = this.$element.find(this.photoFormSelector);
    this.$assetFormTemplate = this.$element.find(
      '.assetDropzone-assetFormTemplate'
    );
    this.$helpElement = this.$element.find('.assetDropzone-help');
    this.$loadingElement = this.$element.find('.assetDropzone-loading');

    this.dropzone = new window.Dropzone(this.photoFormSelector, {
      paramName: this.$element.data('asset-type'),
      maxFiles: 1,
      acceptedFiles: 'image/*',
      clickable: '.assetDropzone',
    });

    this.bindEvents();
  }

  bindEvents() {
    this.handleSuccess = this.handleSuccess.bind(this);
    this.handleSending = this.handleSending.bind(this);
    this.handleDragOver = this.handleDragOver.bind(this);
    this.handleDragLeave = this.handleDragLeave.bind(this);

    this.dropzone.on('success', this.handleSuccess);
    this.dropzone.on('sending', this.handleSending);
    this.dropzone.on('dragover', this.handleDragOver);
    this.dropzone.on('dragleave', this.handleDragLeave);
  }

  unbindEvents() {
    this.dropzone.off('success', this.handleSuccess);
    this.dropzone.off('sending', this.handleSending);
    this.dropzone.off('dragover', this.handleDragOver);
    this.dropzone.off('dragleave', this.handleDragLeave);
  }

  handleDragOver() {
    this.$element.addClass('assetDropzone--dragOver');
  }

  handleDragLeave() {
    this.$element.removeClass('assetDropzone--dragOver');
  }

  handleSending() {
    this.$helpElement.hide();
    this.$loadingElement.show();

    this.handleDragLeave();
  }

  handleSuccess(_, response) {
    const newFormHTML = this.$assetFormTemplate.clone().html();
    const formHTML = newFormHTML
      .replace(/data-src/g, 'src')
      .replace(/__photo_url__/g, response.photo.full.url)
      .replace(/__photo_id__/g, response.id);

    this.hideDropzone();
    this.$element.append(formHTML);
  }

  hideDropzone() {
    this.dropzone.disable();
    this.$photoForm.hide();
  }
}
